<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Unidad</h5>
        </div>
        <emt-form ref="unit-form" v-bind:resource="config.api + '/unit/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="unit-grid" v-bind:resource="config.api + '/unit/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-unit',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre unidad',
                    'placeholder': 'Ingrese nombre de unidad',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'notification',
                    'label': 'Alerta inicial (Días)',
                    'placeholder': 'Alerta inicial (Días)',
                    'value': null,
                    'maxlength': '2',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'notification_end',
                    'label': 'Alerta final (Días)',
                    'placeholder': 'Alerta final (Días)',
                    'value': null,
                    'maxlength': '2',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'days',
                    'label': 'Días ANS',
                    'value': null,
                    'placeholder': 'Días ANS',
                    'maxlength': '2',
                    'type': 'text',
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Nombre unidad',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'notification',
                    'label': 'Alerta inicial (Días)',
                    'ordering': true,
                    'filters': ['exact']
                }, {
                    'name': 'notification_end',
                    'label': 'Alerta final (Días)',
                    'ordering': true,
                    'filters': ['exact']
                }, {
                    'name': 'days',
                    'label': 'Días ANS',
                    'ordering': true,
                    'filters': ['exact']
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/Unit/',
            deleteUrl: Config.api + '/unit/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['unit-grid'].reload()
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-unit.vue?eb65a294